import React, {useContext, useEffect} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {AuthContext} from "../../context/AuthContext";
import {getRefreshTokenSsoApi, loginUserSsoApi} from "./services/AuthServices";
import {getUtenteFromToken} from "../../utility/common";

export default function LoginSso() {

    const searchParams = new URLSearchParams(document.location.search);

    var location = useLocation();
    var hash = location?.state?.hash || ''
    var pwd = searchParams.get('jwt');
    var id = searchParams.get('id');

    const history = useHistory();
    const authContext = useContext(AuthContext);

    async function loginUserSso() {
        const response = await loginUserSsoApi(id, pwd);
        if (response?.data?.result == '0') {
            const respSso = await getRefreshTokenSsoApi(response.data.token);
            if (respSso?.data?.result == '0') {
                localStorage.setItem('ns-refresh-token', respSso.data.data.refresh_token);
                localStorage.setItem('ns-access-token', respSso.data.data.access_token);

                var user = getUtenteFromToken(respSso.data.data.access_token);
                authContext.handleLogin(user, history, hash);
            } else {
                localStorage.removeItem('ns-refresh-token');
                localStorage.removeItem('ns-access-token');
                history.push("/error");
            }
        } else {
            localStorage.removeItem('ns-refresh-token');
            localStorage.removeItem('ns-access-token');
            history.push("/error");
        }
    }

    useEffect(() => {
        if (pwd && pwd !== '') {
            loginUserSso();
        }
    }, [pwd]);

    return (
        <div>
        </div>
    )
}
